import styled from '@emotion/styled';
import { FormControl, MenuItem, Select } from '@mui/material';
import { FC } from 'react';
import { Label } from './Label';

const YearsSelectWrapper = styled(FormControl)`
  .MuiOutlinedInput-root {
    border-radius: 0;
    font-size: 14px;
    font-family: inherit;
    background-color: white;
    height: 55px;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 0px;
  }
`;

const START_YEAR = 2018;

const getYears = () => {
  const today = new Date();
  return Array.from(Array(today.getFullYear() - START_YEAR + 1).keys())
    .map((x) => x + START_YEAR)
    .reverse();
};

export const YearsSelect: FC<{
  value: number;
  setValue: (value: number) => any;
}> = ({ value, setValue }) => (
  <YearsSelectWrapper fullWidth>
    <Label>Rok</Label>
    <Select
      id="demo-simple-select"
      value={value}
      onChange={(e) => setValue(parseInt(e.target.value.toString()))}
    >
      <MenuItem value={0}>Všechny roky</MenuItem>
      {getYears().map((year) => (
        <MenuItem key={year} value={year}>
          {year}
        </MenuItem>
      ))}
    </Select>
  </YearsSelectWrapper>
);
